import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { QueryClient, QueryClientProvider } from 'react-query';
import '_mockApis';
import * as serviceWorker from 'serviceWorker';
import App from 'App';
import { store, persister } from 'store';
import 'assets/scss/style.scss';
import config from 'config';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            // refetchOnWindowFocus: false,
            staleTime: 300 * 1000,
            retry: 1,

        }
    }
});

// ==============================|| REACT DOM RENDER  ||============================== //

ReactDOM.render(
    <QueryClientProvider client={queryClient}>
        <meta name="google" content="notranslate" />
        <Provider store={store}>
            <PersistGate loading={null} persistor={persister}>
                <BrowserRouter basename={config.basename}>

                    <App />
                </BrowserRouter>
            </PersistGate>
        </Provider>
    </QueryClientProvider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
